import { inject, Injectable } from '@angular/core';
import { VacationFormData } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AirportDropDown,
  DestinationType,
  FROM
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  FilterOriginDestDetails,
  PACKAGE_TYPE
} from '@com-delta-idp/mnx-sitewide-shared-utils';
import { BookingVacationFormService } from '../../utils/booking-vacation/booking-vacation-form.service';
import { BookingVacationFacadeBaseService } from './booking-vacation-facade-base.service';

@Injectable({ providedIn: 'root' })
export class BookingVacationFacadeService extends BookingVacationFacadeBaseService {
  override formService = inject(BookingVacationFormService);

  displayAirportModalList(
    type: DestinationType,
    searchTerm: string,
    selectedCode = ''
  ): AirportDropDown {
    const filterOriginDestDetails: FilterOriginDestDetails = {
      isOrigin: type === FROM ? true : false,
      searchQuery: searchTerm,
      pkgType: PACKAGE_TYPE.AIR_HOTEL,
      originCityList: this.adapter.originAirportData,
      destCityList: this.adapter.destinationAirportList
    };

    return this.adapter.transformModalContent(
      filterOriginDestDetails,
      searchTerm,
      this.destinationType$.getValue(),
      selectedCode
    );
  }

  formSubmitted(): void {
    const formValues: VacationFormData = this.vacationWidgetForm.getRawValue();
    const rooms = this.formService.distributePassengersToRooms(
      formValues.numberOfPassengers,
      formValues.numberOfRooms
    );
    const searchObject = this.formService.createSearchObject(formValues, rooms);
    this.formService.navigateToVacationSearch(searchObject);
  }
}
